




























import { computed, defineComponent, PropType, ref, toRef } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/projects/scrileConnect/UserPublicDataProvider";
import useAuthUser from "@/hooks/useAuthUser";
import useNSFWUserSettings from "@/hooks/useNSFWUserSettings";
import useRole from "@/hooks/useRole";
import emitter from "@/lib/emitter";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getLiveUrl, getProfileUrl } from "@/lib/urlHelpers";
import config from "@/config";
import { ViewStoriesSettings } from "@/types";
import { EVENTS } from "@/const";
import ChooseContentConfirm from "@/components/ChooseContentConfirm";
import ProfileHeaderAvatar from "@/components/ProfileHeaderAvatar";
import ProfileHeaderBackground from "@/components/ProfileHeaderBackground";

export default defineComponent({
  name: "ProfileHeader",
  components: { ChooseContentConfirm, ProfileHeaderAvatar, ProfileHeaderBackground },
  props: {
    user: { type: Object as PropType<UserPublicData>, required: true },
  },
  setup(props, { root }) {
    const { authUser } = useAuthUser();
    const { showNotSafeForWork } = useNSFWUserSettings();
    const { isCreator } = useRole(toRef(props, "user"));
    const showChooseContentConfirm = ref(false);
    const isAuthor = computed(() => props.user.id === authUser.value?.id);
    const showStoryCreateBtn = computed(() => config.featureStories && isAuthor.value && isCreator.value);
    const blurred = computed(
      () => !isAuthor.value && isCreator.value && !showNotSafeForWork.value && !props.user.nsfwSettings?.safeForWork
    );
    const showPointer = computed(
      () => (config.featureStories && props.user.hasStories) || props.user.publicLivechatUser
    );
    const showStoriesHandler = () => {
      emitter.emit<ViewStoriesSettings>(EVENTS.STORIES_SHOW, {
        storyPublishers: [{ userId: props.user.id, user: props.user }],
        currentStoryId: props.user.firstNotViewedStoryId || undefined,
        back: getProfileUrl(props.user),
        routeSupport: true,
      });
      showChooseContentConfirm.value = false;
    };
    const background = props.user.background
      ? MediaFilesController.getImageThumbnail(props.user.background.urlPart, "1080p")
      : "";

    const joinLive = () => {
      root.$router.push(getLiveUrl(props.user));
      showChooseContentConfirm.value = false;
    };

    const handleAvatarClick = () => {
      if (config.featureStories && props.user.hasStories) {
        if (props.user.publicLivechatUser) {
          showChooseContentConfirm.value = true;
        } else {
          showStoriesHandler();
        }
      } else if (props.user.publicLivechatUser) {
        joinLive();
      }
    };

    return {
      background,
      showPointer,
      showChooseContentConfirm,
      blurred,
      showStoryCreateBtn,
      showStoriesHandler,
      handleAvatarClick,
      joinLive,
    };
  },
});
